import React from 'react';
import { Card, Typography, Space, Tag, Divider } from 'antd';
import { BellOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const NotificationSettings: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <BellOutlined style={{ marginRight: 8 }} />
              Notification Settings
            </Title>
            <Tag color="blue">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>Notification Preferences</Title>
            <Paragraph>
              This page will allow you to customize your notification preferences.
              Features will include:
            </Paragraph>
            <ul>
              <li>Email notification settings</li>
              <li>Push notification preferences</li>
              <li>SMS notification options</li>
              <li>Notification frequency controls</li>
              <li>Custom notification rules</li>
            </ul>
          </div>
          
          <div style={{ 
            background: '#f6f8fa', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #e1e4e8'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#1890ff' }} />
              <Text type="secondary">
                Notification management features are being developed for better user experience.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default NotificationSettings;
